// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__w0uQL","label":"LabeledBox_label__nZ8se"};